import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

var API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export var fetchRadioStations = createAsyncThunk(
  "radio/fetchRadioStations",
  async function (payload, thunkApi) {
    try {
      var countryCode = payload.countryCode || "EG";
      var language = payload.language || "en";

      var response = await fetch(
        API_BASE_URL +
          "/radio/stations?country_code=" +
          encodeURIComponent(countryCode),
        {
          method: "GET",
          signal: thunkApi.signal,
          headers: {
            Accept: "application/json",
            "Accept-Language": language,
          },
        }
      );

      var responseData = await response.json();

      if (!response.ok) {
        return thunkApi.rejectWithValue(
          responseData.message || "Unable to retrieve radio stations"
        );
      }

      return Array.isArray(responseData.data) ? responseData.data : [];
    } catch (error) {
      return thunkApi.rejectWithValue(
        error.message || "Unable to connect to the server"
      );
    }
  }
);

var initialState = {
  stations: [],
  loading: false,
  error: "",
  selectedCountryCode: "EG",
};

var radioSlice = createSlice({
  name: "radio",
  initialState: initialState,
  reducers: {
    setCountryCode: function (state, action) {
      state.selectedCountryCode = action.payload;
    },
  },
  extraReducers: function (builder) {
    builder
      .addCase(fetchRadioStations.pending, function (state) {
        state.loading = true;
        state.error = "";
      })
      .addCase(fetchRadioStations.fulfilled, function (state, action) {
        state.loading = false;
        state.stations = action.payload;
      })
      .addCase(fetchRadioStations.rejected, function (state, action) {
        state.loading = false;
        state.error = action.payload || "Unable to retrieve radio stations";
      });
  },
});

export var setCountryCode = radioSlice.actions.setCountryCode;
export default radioSlice.reducer;
